import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpDashboardService } from '../../services/dashboard/http-dashboard.service';
import { catchError, finalize } from 'rxjs';
import { DashboardDto } from '../../dto';

// NG-ZORRO Imports
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTableModule } from 'ng-zorro-antd/table';

@Component({
    selector: 'app-dashboard',
    standalone: true,
    imports: [
        CommonModule,
        NzGridModule,
        NzCardModule,
        NzStatisticModule,
        NzIconModule,
        NzSkeletonModule,
        NzDividerModule,
        NzTypographyModule,
        NzTagModule,
        NzTableModule
    ],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {

    dashboard!: DashboardDto | undefined;
    loading = true;

    constructor(
        private httpService: HttpDashboardService,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.fetchDashboard();
    }

    fetchDashboard() {
        this.loading = true;
        this.httpService.getDashboard()
            .pipe(
                catchError(error => {
                    console.log('Error fetching dashboard data', error);
                    this.toastr.error('Failed to fetch dashboard data');
                    throw error;
                }),
                finalize(() => this.loading = false)
            )
            .subscribe(data => {
                this.dashboard = data;
            });
    }
}